import React from "react";
import { Layout } from "antd";

import HeaderMenu from "../../HeaderMenu/HeaderMenu";
import ShiftTable from "./ShiftTable";
import { PageHeader } from "@ant-design/pro-layout";

const { Content } = Layout;

const ShiftTablePage = () => {
  return (
    <>
      <HeaderMenu>
        <PageHeader title={<h1>Shifts</h1>} />
      </HeaderMenu>

      <Content
        style={{
          height: "calc(100vh - 64px)",
          overflowY: "hidden",
          position: "relative",
        }}
      >
        <ShiftTable />
      </Content>
    </>
  );
};

export default ShiftTablePage;
